export function getViewsRoutes() {
  return [
    {
      path: "/stats/views",
      name: "views",
      component: () => import(/* webpackChunkName: views-old-backend */ "./components/ViewsOld.vue"),
    },
  ]
}
